/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by kyang on 7/26/21.
 */

function DynamicStyleServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    $window: JS5Object,
) {

    // Expects color to start with '#', followed by 6-digit hex color (RRGGBB)
    // Returns null if format not matched.
    const cssColorToPercent = (hexColor: string) => {
        let percents = [];
        let hexSection = '([0-9a-fA-F]{2})';
        let matches = hexColor.match('^#'+ hexSection.repeat(3) +'$');
        if (!matches) {
            return null;
        }
        for (let i = 1; i <= 3; ++i) {
            let section = matches[i];
            percents.push(parseInt(section, 16) /255);
        }
        return percents;
    };

    this.setPageTitle = (newTitle?: string) => {
        if (newTitle && $window.document) {
            $window.document.title = newTitle;
        }
    };

    this.setFavicon = (newFaviconUrl?: string) => {
        if (newFaviconUrl && $window.document) {
            let faviconElem = $window.document.head.querySelector('link[rel=icon]');
            if (faviconElem) {
                faviconElem.href = newFaviconUrl;
            } else {
                faviconElem = $window.document.createElement('link');
                faviconElem.rel = 'icon';
                faviconElem.type = 'image/ico';
                faviconElem.href = newFaviconUrl;
                $window.document.head.appendChild(faviconElem);
            }
        }
    };

    this.setPreloaderColor = (cssColor?: string) => {
        if (cssColor) {
            let filterElem = $window.document.body.querySelector('#colorizeProgress > feColorMatrix[type=matrix]');
            if (filterElem) {
                let percents = cssColorToPercent(cssColor);
                if (percents) {
                    filterElem.setAttribute('values', (
                        '0 0 0 0 ' + percents[0] +
                        ' 0 0 0 0 ' + percents[1] +
                        ' 0 0 0 0 ' + percents[2] +
                        ' 0 0 0 1 0'
                    ));
                } else {
                    console.warn(`preloaderColor "${cssColor}" is not in #RRGGBB format. Skipping...`);
                }
            }
        }
    };

    this.setCssVariables = (cssVars: JS5Object) => {
        if (cssVars) {
            let bodyStyles = $window.document.body.style;
            for (let varName in cssVars) {
                if (varName.startsWith('--')) {
                    bodyStyles.setProperty(varName, cssVars[varName]);
                } else {
                    console.warn(`cssVariables prop "${varName}" is not a css variable. Skipping...`);
                }
            }
        }
    };

    this.initialize = () => {
        this.setPageTitle(_.get($window, '__wfcConfig.clientTitle'));
        this.setFavicon(_.get($window, '__wfcConfig.clientFavIcon'));
        this.setPreloaderColor(_.get($window, '__wfcConfig.preloaderColor'));
        this.setCssVariables(_.get($window, '__wfcConfig.cssVariables'));
    }
}

angular
    .module('prism-ui.components.data')
    .service('DynamicStyleService', DynamicStyleServiceConstructor);
